var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{ref:"slider",staticClass:"mdui-slider mdui-slider-discrete",class:{ 'mdui-slider-disabled': _vm.disabled }},[_c('input',{attrs:{"type":"range","step":_vm.step,"min":_vm.min,"max":_vm.max,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit('change', Number($event.target.value))}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }